<template>
  <v-container fluid>
    <v-layout row wrap justify-center>
      <v-flex d-flex xs12 md4>
        <v-select
          :value="data.formation"
          :items="teamFormations"
          :label="$t('fields.matches.formation')"
          :loading="loadingFormation"
          @change="updateFormation"
        />
      </v-flex>
    </v-layout>
    <template v-if="showField">
      <v-layout row wrap justify-center pb-3>
        <v-flex xs12 md6>
          <soccer-field
            :line-up="data.groupByPosition"
            :formation="localFormation"
            :primary-color="data.primaryColor"
            :loading="data.loading"
            :edit="edit"
            @setLineUp="setLineUp"
          />
        </v-flex>
      </v-layout>
      <v-layout
        v-if="data.loading || groupItemsByPositionType.length"
        row
        wrap
        pb-3
      >
        <v-divider />
        <v-flex xs12>
          <line-up-list-group
            :group-title="$t('fields.global.position')"
            :group="groupItemsByPositionType"
            :team-id="teamId"
            :match-id="matchId"
            :team-type="teamType"
            :loading="data.loading"
            :actions="actions"
            :edit="edit"
            @setLineUp="setLineUp"
          />
        </v-flex>
      </v-layout>
    </template>
    <v-layout
      v-if="data.loading || groupItemsByConvocation.length"
      row
      wrap
      pb-3
    >
      <v-divider />
      <v-flex xs12>
        <line-up-list-group
          :group-title="$t('fields.global.convocation')"
          :group="groupItemsByConvocation"
          :team-id="teamId"
          :match-id="matchId"
          :team-type="teamType"
          :loading="data.loading"
          :actions="actions"
          :edit="edit"
          @setLineUp="setLineUp"
        />
      </v-flex>
    </v-layout>
    <dialog-line-up
      ref="form"
      v-model="dialog"
      :team-id="teamId"
      :match-id="matchId"
      :team-type="teamType"
      :line-up-id="lineUpId"
      :actions="actions"
      :edit="edit"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogLineUp from './components/DialogLineUp'
import LineUpListGroup from './components/LineUpListGroup'
import SoccerField from './components/SoccerField'

export default {
  name: 'TeamLineUp',
  components: { LineUpListGroup, DialogLineUp, SoccerField },
  props: {
    teamId: {
      type: String,
      required: true,
      default: '',
    },
    matchId: {
      type: String,
      required: false,
      default: '',
    },
    teamType: {
      type: String,
      required: false,
      default: 'home',
      validator(val) {
        return ['home', 'visitor'].includes(val)
      },
    },
    actions: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      loadingFormation: false,
      lineUpId: '',
      localFormation: '',
    }
  },
  watch: {
    teamId(val) {
      val && this.init()
    },
    matchId(val) {
      val && this.init()
    },
    'data.formation': {
      handler: function (val) {
        this.localFormation = val
      },
      deep: true,
    },
  },

  mounted() {
    this.nextTick(() => {
      this.init()
    })
  },
  computed: {
    ...mapGetters({
      teamFormations: 'teams/teamFormations',
    }),
    groupItemsByPositionType() {
      let groupItems = []
      let groupBy = { ...this.data.groupByPositionType }

      Object.keys(groupBy).forEach((groupName) =>
        groupItems.push({
          title: this.$t(`fields.teams.positionTypes.${groupName}`),
          items: groupBy[groupName],
        })
      )

      return groupItems
    },
    groupItemsByConvocation() {
      let groupItems = []
      let groupBy = { ...this.data.groupByConvocation }

      Object.keys(groupBy).forEach((groupName) =>
        groupItems.push({
          title: this.$t(`fields.teams.convocations.${groupName}`),
          items: groupBy[groupName],
        })
      )

      return groupItems
    },
    showField() {
      if (!this.data.groupItemsByConvocation) return true
      let showField = true

      const { starting, substitute, convocated, noConvocated } =
        this.data.groupItemsByConvocation

      if (this.matchId) {
        if (!starting && !substitute && (convocated || noConvocated))
          showField = false
      }
      return showField
    },
  },
  methods: {
    init() {
      let payload

      if (this.matchId) {
        payload = {
          matchId: this.matchId,
          teamType: this.teamType,
        }
      } else if (this.teamId) {
        payload = this.teamId
      } else return

      this.actions.fetchLineUpList && this.actions.fetchLineUpList(payload)
    },
    updateFormation(formation) {
      this.localFormation = formation
      if (!this.edit) return
      let payload
      if (this.matchId) {
        payload = { _id: this.matchId }
        if (this.teamType === 'home') {
          payload.homeTeamFormation = formation
        } else if (this.teamType === 'visitor') {
          payload.visitorTeamFormation = formation
        }
      } else if (this.teamId) {
        payload = { _id: this.teamId, formation }
      } else return

      if (payload) {
        this.loadingFormation = true
        this.actions.updateFormation &&
          this.actions
            .updateFormation(payload)
            .then(() => {
              this.init()
            })

            .finally(() => {
              this.loadingFormation = false
            })
      }
    },
    setLineUp(lineUp = {}) {
      this.nextTick(() => {
        this.$refs.form && this.$refs.form.setLineUp(lineUp)
      })
    },
  },
}
</script>
